import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import BetslipButton from 'modules/betslip-button/index.js';
import FloatingBetslipPill from 'modules/floating-betslip-pill/index.js';

const { BottomSheet, BottomSheetState } = MojitoPresentation.Components;
const SlidingPane = MojitoPresentation.Components.SlidingPane.component;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

const BETSLIP_BUTTON_SLIDING_STATE = {
    OPENED: 'openedBetslipButtonState',
    CLOSED: 'closedBetslipButtonState',
};

export default class SlidingBetslipView extends UIViewImplementation {
    renderBetslipButton() {
        const { OPENED, CLOSED } = BETSLIP_BUTTON_SLIDING_STATE;
        const sliderState = this.props.isOpen ? OPENED : CLOSED;
        if (this.style.hideBetslipButton[sliderState]) {
            return null;
        }

        let container;
        let button;
        if (this.props.isBetslipButtonMinimized) {
            container = this.style.minimizedBetslipButtonContainer[sliderState];
            button = this.style.minimizedBetslipButton[sliderState];
        } else {
            container = this.style.betslipButtonContainer[sliderState];
            button = this.style.betslipButton[sliderState];
        }
        return (
            <div className="ta-betslipButtonContainer" style={container}>
                <BetslipButton
                    disabled={this.props.isBetslipButtonDisabled}
                    showImage={this.props.isBetslipButtonCommitted && this.props.isOpen}
                    config={button}
                    enableFreebetsIndication={this.props.enableFreebetsIndication}
                    isQuickBetslip={this.props.isQuickBetslip}
                    onClick={this.props.onBetslipButtonClick}
                />
            </div>
        );
    }

    renderFloatyBetslipButton() {
        const { isOpen, isQuickBetslip, isBetslipButtonCommitted, enableFreebetsIndication } =
            this.props;

        return (
            <FloatingBetslipPill
                isOpen={isOpen}
                isQuickBetslip={isQuickBetslip}
                config={this.config.floatingBetslipPill}
                enableFreebetsIndication={enableFreebetsIndication}
                isBetslipCommitted={isBetslipButtonCommitted}
                onClick={this.props.onBetslipButtonClick}
            />
        );
    }

    renderContent() {
        if (this.config.betslipOptions.floating.enabled) {
            return this.renderBottomSheet();
        }

        return this.renderSlidingPane();
    }

    renderBottomSheet() {
        const { isOpen, onSwipeDown, onSwipeUp, children, isQuickBetslip } = this.props;
        const isFullBetslip = !isQuickBetslip;
        const openedState = isFullBetslip
            ? BottomSheetState.OPENED
            : BottomSheetState.PARTLY_OPENED;
        const state = isOpen ? openedState : BottomSheetState.CLOSED;

        return (
            <BottomSheet
                state={state}
                onSwipeUp={onSwipeUp}
                onSwipeDown={onSwipeDown}
                config={this.config.bottomSheet}
                headerElement={this.renderFloatyBetslipButton()}
            >
                {children}
            </BottomSheet>
        );
    }

    renderSlidingPane() {
        const { slidingPane } = this.config;
        const { isOpen, onCloseClick, onClickOutside, onClosed, children } = this.props;
        const style = isOpen ? this.style.opened : this.style.closed;

        return (
            <SlidingPane
                isOpen={isOpen}
                config={slidingPane}
                onCloseClick={onCloseClick}
                onClickOutside={onClickOutside}
                onClosed={onClosed}
            >
                <div style={style.container}>
                    {children}
                    {this.renderBetslipButton()}
                </div>
            </SlidingPane>
        );
    }

    render() {
        return this.renderContent();
    }
}

SlidingBetslipView.getStyle = (config, applicationMode, merge) => {
    const buildBetslipButtonStyles = state => {
        const configState = config[state];
        // the props are frozen by react in <div className="ta-betslipButtonContainer" style={container}>
        return structuredClone({
            hideBetslipButton: {
                [state]: configState.hide,
            },
            betslipButtonContainer: {
                [state]: configState.container.style,
            },
            betslipButton: {
                [state]: configState.button,
            },
            minimizedBetslipButtonContainer: {
                [state]: configState.minimizedContainer.style,
            },
            minimizedBetslipButton: {
                [state]: configState.minimizedButton,
            },
        });
    };
    const { OPENED, CLOSED } = BETSLIP_BUTTON_SLIDING_STATE;
    const baseStyles = config.style.base;
    return {
        ...merge(buildBetslipButtonStyles(OPENED), buildBetslipButtonStyles(CLOSED)),
        opened: merge(baseStyles, config.style.opened),
        closed: merge(baseStyles, config.style.closed),
    };
};
